module.exports = __webpack_public_path__ + "assets/img/case-country1.a2de1246.png";